<template>
    <div class="container h-100">
        <div class="dept-container">
            <el-table
                    :data="treeData"
                    row-key="id"
                    :tree-props="{children: 'children'}"
                    style="width: 100%"
                    :show-header=false
            >
                <el-table-column prop="dept_name" label="部门名称"></el-table-column>
<!--                <el-table-column prop="order_num" label="排序" width="60" align="center"></el-table-column>-->
                <el-table-column label="创建时间" align="center" prop="created_at" />
                <el-table-column label="修改时间" align="center" prop="updated_at" />
            </el-table>
        </div>
    </div>

</template>

<script>
  import { getDept } from '@/api/dingTalk'
  export default {
    name: "Test",
    data(){
      return {
        data : [],
      }
    },
    computed:{
      // 处理数据结构，得到树形结构数据
      treeData(){
        let cloneData = JSON.parse(JSON.stringify(this.data))    // 对源数据深度克隆
        return cloneData.filter(father=>{
          let branchArr = cloneData.filter(child=>father.dept_id == child.parent_id)    //返回每一项的子级数组
          branchArr.length>0 ? father.children = branchArr : ''   //如果存在子级，则给父级添加一个children属性，并赋值
          return father.parent_id == 0;      //返回第一层
        });
      }
    },
    methods:{
      // 获取 钉钉部门 信息
      getDeptData(){
        getDept().then(res => {
          this.data = res.model
        })
      },
    },
    created(){
        this.getDeptData()
    }
  }
</script>

<style scoped>
    .dept-container{
        width: 50%;
        min-width: 800px;
        margin: auto;
    }
    /*.el-table th.el-table__cell {*/
    /*    overflow: hidden;*/
    /*    -webkit-user-select: none;*/
    /*    -moz-user-select: none;*/
    /*    user-select: none;*/
    /*    background-color: #FFF;*/
    /*    background: #ff3176 !important;*/
    /*    color: #000;*/
    /*    font-size: 20px;*/
    /*    text-align: center;*/
    /*}*/
</style>